export enum PopMenuVariant {
  onWhite = 'on-white',
  onGray = 'on-gray',
  onBlueberry = 'on-blueberry',
}

export enum PopMenuLabelPosition {
  right = 'right',
  left = 'left',
}
